export default __webpack_public_path__ + "static/media/pin-map-icon.3e0e561b.svg";